export function intOr(fallback, mixed) {
  const val = parseFloat(mixed);
  return isNaN(val) ? fallback : val;
}
